import SearchBarUserName from "../search-bar/SearchBarUserName";
import {Field} from "formik";
import React from "react";
import useFilterUser from "../../custom-hooks/useFilterUser";
import styled from "styled-components";

const SelectProjectInputFormik = ({handleTagDisplay,projects, projectId}) => {
    const {
        query,
        setQuery
    } = useFilterUser(projects)

    return (
        <div>
            <label> Choisir un projet  </label>
            <SearchBarUserName
                setQuery={setQuery}
                name={'projet'}
            />
            <Wrapper>
                <Projects>
                    {projects.length > 0 &&
                    projects
                        .filter(project => project.name.toLowerCase().includes(query.toLowerCase()))
                        .map(project => (
                            <InputContainer key={project.id + '/' + project.name}>
                                <label>
                                    <Field
                                        type={"radio"}
                                        name={'projectId'}
                                        value={project.id}
                                        checked={project.id.toString() === projectId?.toString()}
                                        onClick={()=>handleTagDisplay(project.id)}
                                    />
                                    <Project>
                                        <p> {project.name} </p>
                                    </Project>
                                </label>
                            </InputContainer>
                        ))}
                </Projects>
            </Wrapper>

        </div>
    )
}


const Wrapper = styled.div`
  height: 200px;
  overflow-y: auto;
`

const Projects = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
  width: 100%;
`
const Project = styled.div`
  border: 1px solid var(--color-purple-lighten);
  padding: 0.5rem 1rem;
  border-radius: 10px;
  cursor: pointer;

  p {
    font-weight: 500;
  }

  :hover {
    background: var(--color-purple-06);
    p{
      color:var(--color-white)

    }
  }

`

const InputContainer = styled.div`
  overflow: hidden;

  label > input {
    opacity: 0;
    display: none;
  }

  label > input:checked + div {
    background-color: var(--color-purple-06);
    p{
      color:var(--color-white)

    }
  }
`
export default SelectProjectInputFormik